export interface CreateGroupValues {
  name: string;
  description: string;
}

export interface RegisterUserValues {
  email: string;
  full_name: string;
  user_name: string;
  role: string;
}

export type CreateGroupErrors = Partial<Record<'name', string>>;
export type RegisterUserErrors = Partial<
  Record<'email' | 'full_name' | 'user_name' | 'role', string>
>;

const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const validateCreateGroupValues = (values: CreateGroupValues): CreateGroupErrors => {
  const errors: CreateGroupErrors = {};

  if (!values.name.trim()) {
    errors.name = 'Введите название группы';
  }

  return errors;
};

export const validateRegisterUserValues = (values: RegisterUserValues): RegisterUserErrors => {
  const errors: RegisterUserErrors = {};

  if (!values.email.trim()) {
    errors.email = 'Введите email';
  } else if (!emailPattern.test(values.email.trim())) {
    errors.email = 'Введите корректный email';
  }

  if (!values.full_name.trim()) {
    errors.full_name = 'Введите полное имя';
  }

  if (!values.user_name.trim()) {
    errors.user_name = 'Введите имя пользователя';
  }

  if (!values.role.trim()) {
    errors.role = 'Выберите роль пользователя';
  }

  return errors;
};

export const validateSelection = (value: string, message: string): string =>
  value.trim() ? '' : message;

export const hasValidationErrors = (errors: Record<string, string | undefined>): boolean =>
  Object.values(errors).some(Boolean);
